<template>
  <div class="animated fadeIn" id="showEngineer">
    <b-card>
      <div class="showClock" v-if="show">
        <time-now></time-now>
      </div>

      <div class="table engineer bottom-border" id="tableEngineer">
        <template v-for="(engineer, index) in data">
          <template v-if="!beforePIC[index]">
            <div class="row row-pic xcycle" :id="'row-pic-' + index" style="padding: 0 15px;">
              <div
                class="col-lg-2 col-md-3 col-sm-4 border"
                style="padding: 15px; text-align: right;"
              >
                <a
                  :href="engineer.position"
                  v-bind:title="desc.presence[engineer.presence].desc"
                  v-bind:style="{color: desc.presence[engineer.presence].color}"
                >{{engineer.name}}</a>
                <span
                  class="text-time text-success"
                  v-if="engineer.presence == 1"
                >({{engineer.last_update | diffTimeNow }})</span>
                <template v-if="!engineer.position & engineer.presence == 1">
                  <div>
                    <i class="fa fa-times text-danger"></i> location
                  </div>
                </template>
                <div v-if="engineer.ticket.length > 5 && !showMore[index]">
                  <button
                    class="btn btn-link"
                    @click="showingMore(index)"
                  >&hellip;({{ engineer.ticket_count - 5 }})</button>
                </div>
              </div>
              <div class="col-lg-10 col-md-9 col-sm-8 border">
                <!--untuk 2 colomn-->
                <!--<div class="row">-->
                <!--<template v-for="(ticket, i) in engineer.ticket" >-->
                <!--<div class="col-md-6">-->

                <!--<b-card class="ticketCard">-->
                <!--<template v-if="i < 6">-->
                <!--<LiveReportTicketComponent :ticket="ticket" :desc="desc" :i="i" />-->
                <!--</template>-->
                <!--<template v-if="i >= 6 && showMore[index]">-->
                <!--<LiveReportTicketComponent :ticket="ticket" :desc="desc" :i="i" />-->
                <!--</template>-->

                <!--</b-card>-->

                <!--</div>-->

                <!--</template>-->
                <!--</div>-->
                <!--Tampilan Ticket yang menggunakan Table-->
                <table class="address" width="100%">
                  <tr v-for="(ticket, i) in engineer.ticket" v-bind:key="ticket.ticket_id">
                    <template v-if="i < 5">
                      <LiveReportTicketComponent :ticket="ticket" :desc="desc" :i="i"/>
                    </template>
                    <template v-if="i >= 5 && showMore[index]">
                      <LiveReportTicketComponent :ticket="ticket" :desc="desc" :i="i"/>
                    </template>
                    <!-- ini sementara tombol belum hilang ketika click -->
                  </tr>
                </table>
              </div>
            </div>
          </template>
          <template v-else>
            <span>
              <a
                :href="engineer.position"
                v-bind:title="desc.presence[engineer.presence].desc"
                v-bind:style="{color: desc.presence[engineer.presence].color}"
              >{{engineer.name}}</a> &nbsp;
            </span>
          </template>
        </template>

        <template v-if="show">
          <div class="xcycle footer-legend" :id="'row-pic-' + data.length">
            <b-row>
              <div class="col-md-4">
                <div style="text-align: left; padding-left: 1em;">
                  PIC : &nbsp;
                  <label
                    v-for="(presence, i) in desc.presence"
                    v-bind:key="`presence-${i}`"
                    v-bind:style="{color: presence.color}"
                  >
                    <span class="dot" v-bind:style="{background: presence.color}"></span>
                    {{presence.desc}} &nbsp;&nbsp;
                  </label>
                </div>
              </div>
              <div class="col-md-4" style="margin-bottom: 4px">
                <div style="text-align: center">
                  <i class="fa fa-caret-square-o-right positionStatusTicket"></i> &nbsp;
                  <b>Work</b> &nbsp;
                  <i class="fa fa-check-square-o positionStatusTicket"></i> &nbsp;
                  <label style="color: #CCC">Solved / Closed</label> &nbsp;
                  <i class="fa fa-calendar-check-o positionStatusTicket"></i> &nbsp;
                  <del>Pending</del> &nbsp;
                  <i class="fa fa-square-o positionStatusTicket"></i> &nbsp; Open &nbsp;
                </div>
              </div>
              <div class="col-md-4">
                <div style="text-align: right; padding-right: 1em;">
                  Ticket : &nbsp;
                  <label
                    v-for="(status, key) in desc.ticket_type"
                    :key="key"
                    v-bind:style="{color: status.color}"
                  >
                    <span class="dot" v-bind:style="{background: status.color}"></span>
                    {{status.name}} &nbsp;&nbsp;
                  </label>
                </div>
              </div>
            </b-row>
            <b-row>
              <div class="col-md-12" style="text-align: center">
                <img :src="$store.getters.base_href + '/iconTicket/req.png'">:&nbsp;Request&nbsp;&nbsp;&nbsp;
                <img :src="$store.getters.base_href + '/iconTicket/request16.png'">:&nbsp;Incident/ NOC &nbsp;&nbsp;
                <img :src="$store.getters.base_href + '/iconTicket/bongkar16.png'"> :&nbsp;Dismantle&nbsp;&nbsp;
                <img :src="$store.getters.base_href + '/iconTicket/pasangbaru16.png'"> :&nbsp;Instalasi Baru&nbsp;&nbsp;
                <img :src="$store.getters.base_href + '/iconTicket/survay16.png'"> :&nbsp;Survey Lokasi&nbsp;&nbsp;
                <img :src="$store.getters.base_href + '/iconTicket/pantaulink16.png'"> :&nbsp;Pantau Link&nbsp;&nbsp;
                <img :src="$store.getters.base_href + '/iconTicket/pindahperangkat16.png'"> :&nbsp;Pindah Perangkat&nbsp;&nbsp;
                <img :src="$store.getters.base_href + '/iconTicket/fiberoptic162.png'"> :&nbsp;Fiber Optic&nbsp;&nbsp;
                <img :src="$store.getters.base_href + '/iconTicket/other16.png'"> :&nbsp;Others&nbsp;&nbsp;
              </div>
            </b-row>
          </div>
        </template>
      </div>

      <!--untuk 3 kolom-->
      <!--<b-row v-if="show">
        <div class="col-md-4">
          <b>Presence</b>
          <div v-for="(presence, i) in desc.presence" v-bind:key="`presence-${i}`">
            <span class="dot" v-bind:style="{background: presence.color}"></span> &nbsp; {{presence.desc}}
          </div>
        </div>
        <div class="col-md-4">
          <b>Status</b>
          <div>
            <i class="fa fa-caret-square-o-right"></i> &nbsp; Work
          </div>
          <div>
            <i class="fa fa-check-square-o"></i> &nbsp; Solved / Closed
          </div>
          <div>
            <i class="fa fa-calendar-check-o"></i> &nbsp; Pending
          </div>
          <div>
            <i class="fa fa-square-o"></i> &nbsp; Open
          </div>
        </div>
        <div class="col-md-4">
          <b>Type Ticket</b>
          <div v-for="(status, key) in desc.ticket_type" :key="key">
            <span class="dot" v-bind:style="{background: status.color}"></span> &nbsp; {{status.name}}
          </div>
        </div>
      </b-row>-->
    </b-card>
  </div>
</template>

<script>
import { getService } from "../../services";
import LiveReportTicketComponent from "./LiveReportTicketComponent";
import moment from "moment";
import Vue from "vue";
import TimeNow from "../../component/TimeNow";
export default {
  name: "livereport",
  components: {
    LiveReportTicketComponent,
    TimeNow
  },
  data() {
    return {
      data: [],
      branch: "020",
      show: false,
      branchs: [],
      desc: [],
      condition: false,
      heightReport: 0,
      heightWindow: 0,
      position: 0,
      positionEngineer: [],
      showMore: [],
      runFirst: true,
      timeNow: null,
      oldPosition: 0,
      checkYOffset: "",
      beforePIC: []
    };
  },
  mounted: function() {
    if (this.$route.name == "Engineer" || this.$route.name == "EngineerBali" || this.$route.name == "EngineerLampung") {
      if (this.$route.name == "Engineer") {
        this.branch = "020";
      } else if (this.$route.name == "EngineerLampung") {
        this.branch = "090";
      } else {
        this.branch = "062";
      }
      this.getLiveNoToken(this.branch);
      let that = this;
      this.timeNow = moment().format("x") / 1000;
      setInterval(() => {
        that.updateTime();
      }, 1000);
      setInterval(() => {
        that.getLiveNoToken(this.branch);
      }, 300000);
    } else if (this.$route.name == "livereport") {
      this.getBranch();
    } else {
      alert("NO ACCESS");
    }
  },
  methods: {
    updateTime() {
      this.timeNow = moment().format("x") / 1000;
    },
    submit: function() {
      this.getLive(this.branch, false);
    },
    live: function() {
      this.getLive(this.branch, true);
    },
    getLive: function(branch, live) {
      this.$store.commit("noLoad", true);
      getService.list_live_enginer(branch, live).then(data => {
        this.data = [];
        this.show = true;
        this.$store.commit("noLoad", false);
        this.data = data.data;
        this.desc = data.desc;
      });
    },
    getLiveNoToken: function(branch) {
      getService.list_live_engineer_notoken(branch).then(data => {
        let that = this;
        // console.log('sudah update')
        var i = 0;
        let dataEngineer = [];
        let inWork, outWork, now;
        now = moment().format('x')
        // untuk hari sabtu
        if (moment().day() == 6) {
          inWork = moment(8, 'HH').format('x')
          outWork = moment(12, 'HH').format('x')
        } else if (moment().day() == 0) {
          inWork = moment(0, 'HH').format('x')
          outWork = moment(1, 'HH').format('x')
        } else {
          inWork = moment(8, 'HH').format('x')
          outWork = moment(17, 'HH').format('x')
        }

        for (var engineer of data.data) {
          engineer.name = engineer.name
            .trim()
            .split(/\s+/)
            .map((x, i) => (i < 1 ? x : x[0]))
            .reduce((a, b, i) => [a, b].join(i < 3 ? " " : "").trim());

          // sort dari ko david
          engineer.ticket.sort((a, b) => {
            // a.current_ticket - b.current_ticket
            // if (!(a.status == 'Solved' || a.status == 'Closed') && (b.status == 'Solved' || a.status == 'Closed')) return 1
            // if ((a.status == 'Solved' || a.status == 'Closed') && !(b.status == 'Solved' || a.status == 'Closed')) return -1
            // if (a.status != 'Pending' && b.status == 'Pending') return 1
            // if (a.status == 'Pending' && b.status != 'Pending') return -1
            // if (a.current_ticket - b.current_ticket) return 1
            // if (a.current_ticket && !b.current_ticket) return -1
            // if (a.status != 'Open' && b.status == 'Open') return 1
            // if (a.status == 'Open' && b.status != 'Open') return -1
            // if (a.type != 'Dedicated' && b.type == 'Dedicated') return 1
            // if (a.type == 'Dedicated' && b.type != 'Dedicated') return -1
            // if (a.type != 'Broadband' && b.type == 'Broadband') return 1
            // if (a.type == 'Broadband' && b.type != 'Broadband') return -1
            // return 0
          });

          //sort albert
          engineer.ticket.sort((a, b) => {
            if (a.current_ticket === 1 && a.status === "Open") return -1;
            if (b.current_ticket === 1 && b.status === "Open") return 1;
            if (
              a.status === "Open" &&
              b.status === "Open" &&
              a.visit_time_sort &&
              a.visit_time_sort < b.visit_time_sort
            )
              return -1;
            if (
              a.status === "Open" &&
              b.status === "Open" &&
              a.visit_time_sort &&
              a.visit_time_sort < b.visit_time_sort
            )
              return 1;
            if (
              a.status === "Open" &&
              b.status === "Open" &&
              !a.visit_time_sort &&
              b.visit_time_sort
            )
              return 1;
            if (
              a.status === "Open" &&
              b.status === "Open" &&
              a.visit_time_sort &&
              !b.visit_time_sort
            )
              return -1;
            if (a.status === "Pending") return 1;
            if (a.status !== "Open" && b.status === "Pending") return -1;
            if (a.status !== "Open" && b.status === "Open") return 1;
            if (a.status === "Open" && b.status !== "Open") return -1;
            if (a.status === "Open" || b.status === "Open") return -1;
            return -1;
          });
          if(engineer.presence == 1) {
            dataEngineer.push(engineer)
          } else if (now >= inWork && now <= outWork) {
            dataEngineer.push(engineer)
          }
          // console.log(engineer.ticket)
        }
        this.data = dataEngineer;
        for (let i = 0; i < this.data.length; i++) {
          Vue.set(this.beforePIC, i, false);
        }
        for (let j = 0; j < this.data.length; j++) {
          if (j > 0) {
            if (
              this.data[j].presence == 0 &&
              this.data[j - 1].presence == 0 &&
              this.data[j].ticket.length == 0 &&
              this.data[j - 1].ticket.length == 0
            ) {
              Vue.set(this.beforePIC, j, true);
              Vue.set(this.beforePIC, j - 1, true);
            }
          }
          this.showMore[j] = this.data[j].ticket.length <= 5;
          Vue.set(this.data, j, this.data[j]);
        }
        this.desc = data.desc;
        this.show = true;
        that.position = 0;
        that.checkRun();
      });
    },
    /*getHeightElement() {
        let array = []
        for (var i = 0; i < this.$refs.eng.length; i++) {
            array.push(this.$refs.eng[i].getBoundingClientRect().top )
        }
        this.positionEngineer = array
      },
      checkElement(height) {
        for (let i = 1; this.positionEngineer.length; i++ ) {
          if (this.positionEngineer[i - 1] < height && this.positionEngineer[i] > height) {
            return this.positionEngineer[i-1]
          } else if (this.positionEngineer[i] <= height) {
            return height
          }
        }
      },*/

    checkRun() {
      if (this.setTime) return;
      var run = () => {
        var pageofScreen = window.pageYOffset;
        window.scrollTo(0, pageofScreen + 1);
        this.checkItemCycle();
        if (document.getElementById('tableEngineer').offsetHeight < window.innerHeight) {
          clearInterval(this.setTime)
        }
      };
      run();
      this.setTime = setInterval(run, 1000 / 10);

    },

    checkItemCycle() {
      var nodes = document.getElementsByClassName("xcycle");
      var nodesCollected = [];
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes.item(i);
        
        if (window.pageYOffset > node.offsetTop + node.offsetHeight) {
          nodesCollected.push(node);
        } else {
          break;
        }
        if (nodesCollected.length >= 2) {
          for (var j = 0; j < 2; j++) {
            var node = nodesCollected[j];
            document.getElementById("tableEngineer").appendChild(node);
          }
          break;
        }
      }
    },

    compareStrings(a, b, condition) {
      // Assuming you want case-insensitive comparison
      if (typeof a == "string") {
        a = a.toLowerCase();
        b = b.toLowerCase();
      }
      if (condition) {
        return a < b ? -1 : a > b ? 1 : 0;
      } else {
        return a > b ? -1 : a < b ? 1 : 0;
      }
    },
    sort(name, type) {
      var that = this;
      var condition, key;
      if (this.condition) {
        condition = true;
      } else {
        condition = false;
      }
      key = type == "string" ? "name" : "ticket_count";
      this.condition = !this.condition;
      name.sort(function(a, b) {
        return that.compareStrings(a[key], b[key], condition);
      });
    },
    async getBranch() {
      try {
        await getService.list_branch().then(data => {
          this.branchs = data;
        });
      } catch (error) {
        // bila data tidak terpanggil
      }
    },

    showingMore: function(index) {
      Vue.set(this.showMore, index, true);
    },
    checkPostion() {
      var position;
      position = window.pageYOffset;
      if (position == this.oldPosition) {
        location.reload();
      } else {
        this.oldPosition = position;
      }
    }
  }
};
window.requestAnimFrame = (function() {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function(callback) {
      window.setTimeout(callback, 1000 / 60);
    }
  );
})();

</script>

<style scoped>
.card {
  margin-bottom: 0px !important;
}

.text-time {
  font-size: 10px;
  display: block;
}

table.address > tr > td {
  border: 0px !important;
}

td.number {
  min-width: 50px;
  padding-right: 2px;
  padding-left: 5px;
}

td.ticket {
  padding-left: 5px;
}

.engineer > .row-pic:nth-child(2n) {
  background-color: rgba(32, 168, 216, 0.1);
}

.title {
  font-weight: bold;
  font-size: 15px;
}
@media only screen and (max-width: 767px) {
  .mobile {
    display: none;
  }
}

.positionStatusTicket {
  margin-top: 4px;
}

.showClock {
  right: 20px;
  top: 10px;
  background-color: #efefee;
  position: fixed;
  z-index: 2;
  width: 120px;
  text-align: center;
}

.card-body {
  padding: 0px;
}

.ticketCard {
  background-color: #fff0;
  border: 0 !important;
}

.no-presence {
  display: inline-block;
}

.bottom-border {
  border-bottom: 1px solid #ccc;
  margin: 0;
}

.footer-legend {
  padding: 1em 0;
  background-color: #eeffee;
}

</style>
